import { createTheme, ThemeProvider } from '@mui/material/styles';

export const GlobalThemeProvider = ({ children }: any) => {
  return <ThemeProvider theme={createTheme()}>{children}</ThemeProvider>;
};
